import React from 'react';

function Terminos() {
  return (
    <div className="container my-5" style={{ maxWidth: '800px' }}>
      {/* Header */}
      <div className="text-center mb-5">
        <h1 className="display-5 fw-bold mb-3">Términos y Condiciones de Uso</h1>
        <p className="text-muted">LemmonTags</p>
        <p className="text-muted small">Última actualización: 21 de junio de 2025</p>
      </div>

      {/* Banner - Derecho a No Aceptar */}
      <div className="alert alert-success border-success mb-4">
        <h5 className="alert-heading">
          <i className="bi bi-shield-check me-2"></i>
          Tu Derecho a No Aceptar
        </h5>
        <p>
          Si no estás de acuerdo con alguno de estos Términos o con nuestro Aviso de Privacidad, 
          <strong> estás en tu derecho de no aceptarlos</strong>.
        </p>
        <p className="mb-0">
          Puedes solicitar una <strong>devolución del 100% del precio del producto</strong> dentro 
          de los primeros <strong>30 días naturales</strong> después de tu compra. 
          <span className="text-muted"> (Los gastos de envío no son reembolsables)</span>
        </p>
        <hr className="my-3" />
        <p className="mb-0 small">
          <strong>Contacto:</strong>{" "}
          <a href="mailto:soporte@lemmontags.com" className="alert-link">soporte@lemmontags.com</a>
          {" | "}
          <a href="#seccion-devolucion" className="alert-link">Ver detalles de devolución</a>
        </p>
      </div>

      <hr className="my-4" />

      {/* Sección 1 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">1. Aceptación de los Términos</h4>
        <p>
          Bienvenido a LemmonTags. Al acceder, registrarte o utilizar nuestro sitio web, aplicación 
          móvil y servicios (en conjunto, "el Servicio"), aceptas estar sujeto a los siguientes 
          Términos y Condiciones ("los Términos").
        </p>
        
        <div className="alert alert-primary">
          <h6 className="mb-3">
            <i className="bi bi-hand-thumbs-up me-2"></i>
            Derecho a No Aceptar
          </h6>
          <p>
            <strong>Si no estás de acuerdo</strong> con todos o algunos de estos términos, 
            o con nuestra forma de tratar tus datos personales, <strong>NO utilices nuestro Servicio</strong>.
          </p>
          <p className="mb-0">
            Tienes derecho a solicitar una <strong>devolución del 100% del precio del producto</strong> 
            dentro de los primeros <strong>30 días naturales</strong> desde tu compra. Los gastos de 
            envío (original y de devolución) no son reembolsables. Para solicitar tu devolución, 
            contacta: <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>
          </p>
        </div>
      </section>

      {/* Sección 2 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">2. Descripción del Servicio</h4>
        <p>
          LemmonTags proporciona etiquetas inteligentes (Tags) con códigos QR que se vinculan a un 
          perfil digital en nuestra plataforma. El objetivo principal del Servicio es facilitar la 
          recuperación de mascotas u objetos perdidos mediante un canal de comunicación anónimo entre 
          el propietario ("el Titular") y la persona que encuentra el bien ("el Localizador").
        </p>
        
        <div className="alert alert-warning mt-3">
          <h6 className="alert-heading">
            <i className="bi bi-exclamation-triangle me-2"></i>
            Importante: Naturaleza del Servicio
          </h6>
          <p className="mb-0">
            <strong>LemmonTags es una herramienta de ayuda y facilitación tecnológica.</strong> NO 
            garantizamos la recuperación de ninguna mascota u objeto perdido. El Servicio únicamente 
            proporciona un medio de comunicación entre el propietario y quien encuentre el bien. 
            La recuperación final depende de factores externos que están fuera de nuestro control.
          </p>
        </div>
      </section>
      {/* Sección 2.5 - NUEVA Y CRÍTICA */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">2.5. Canales de Venta Oficiales y Autenticidad del Producto</h4>
  
  <div className="alert alert-success mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-shop me-2"></i>
      Canales de Venta Oficiales
    </h6>
    <p>
      Los productos de LemmonTags se venden <strong>exclusivamente</strong> a través de los 
      siguientes canales oficiales:
    </p>
    <ol className="mb-0">
      <li>
        <strong>Tienda en línea oficial:</strong>{" "}
        <a href="https://lemmontags.com" target="_blank" rel="noopener noreferrer">
          https://lemmontags.com
        </a> (plataforma montada en PrestaShop)
      </li>
      <li>
        <strong>Puntos de venta autorizados:</strong> Establecimientos físicos oficialmente 
        acreditados por Inqubits S.A. de C.V., los cuales están listados en{" "}
        <a href="https://lemmontags.com/puntos-de-venta" target="_blank" rel="noopener noreferrer">
          https://lemmontags.com/puntos-de-venta
        </a>
      </li>
    </ol>
  </div>

  <h6 className="fw-bold mt-4">Métodos de Pago Oficiales:</h6>
  <p>En nuestra tienda en línea oficial (<a href="https://lemmontags.com">lemmontags.com</a>), aceptamos los siguientes métodos de pago:</p>
  <div className="row mb-3">
    <div className="col-md-4 mb-2">
      <div className="card h-100">
        <div className="card-body text-center">
          <i className="bi bi-bank2 fs-3 text-primary mb-2"></i>
          <p className="mb-0 small"><strong>Transferencia Bancaria</strong><br />SPEI</p>
        </div>
      </div>
    </div>
    <div className="col-md-4 mb-2">
      <div className="card h-100">
        <div className="card-body text-center">
          <i className="bi bi-credit-card fs-3 text-info mb-2"></i>
          <p className="mb-0 small"><strong>MercadoPago</strong><br />Tarjetas y meses sin intereses</p>
        </div>
      </div>
    </div>
    <div className="col-md-4 mb-2">
      <div className="card h-100">
        <div className="card-body text-center">
          <i className="bi bi-shop fs-3 text-success mb-2"></i>
          <p className="mb-0 small"><strong>OXXO Pay</strong><br />Pago en efectivo</p>
        </div>
      </div>
    </div>
  </div>

  <div className="alert alert-danger mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-exclamation-octagon me-2"></i>
      Advertencia: Productos No Oficiales y Falsificaciones
    </h6>
    <p>
      <strong>Cualquier sitio web, tienda en línea, o establecimiento físico que NO esté
      listado oficialmente en <a href="https://lemmontags.com">lemmontags.com</a> se considera
      un canal NO AUTORIZADO.</strong>
    </p>
    <p className="mb-3">
      La compra de productos LemmonTags en canales no autorizados conlleva los siguientes riesgos:
    </p>
    <ul className="mb-3">
      <li><strong>Producto falsificado o de baja calidad</strong> que no cumple nuestros estándares</li>
      <li><strong>Tags que no funcionan</strong> con nuestra plataforma o que tienen códigos inválidos</li>
      <li><strong>Sin garantía:</strong> No ofrecemos garantía, soporte técnico ni reembolsos para productos 
          adquiridos en canales no oficiales</li>
      <li><strong>Riesgos de seguridad:</strong> Tags falsificados pueden contener malware o códigos maliciosos</li>
      <li><strong>Pérdida de tu inversión</strong> sin posibilidad de recuperar tu dinero</li>
    </ul>
    <p className="mb-0">
      <strong>Inqubits S.A. de C.V. NO se hace responsable</strong> por productos adquiridos en 
      canales no autorizados, incluyendo pero no limitado a: mercados en línea no oficiales 
      (Mercado Libre, Amazon vendedores terceros, etc.), tiendas físicas no listadas, revendedores 
      no autorizados, o redes sociales.
    </p>
  </div>

  <div className="card border-info">
    <div className="card-header bg-info text-white">
      <strong>
        <i className="bi bi-patch-check me-2"></i>
        ¿Cómo Verificar la Autenticidad de tu Tag?
      </strong>
    </div>
    <div className="card-body">
      <p>
        Si adquiriste un Tag de LemmonTags en un lugar <strong>que no aparece en nuestra lista 
        de canales oficiales</strong>, o tienes dudas sobre su autenticidad, sigue estos pasos:
      </p>
      <ol className="mb-3">
        <li>
          Envía un correo electrónico a{" "}
          <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>
        </li>
        <li>
          <strong>Asunto:</strong> "Verificación de autenticidad de producto"
        </li>
        <li>
          <strong>Incluye:</strong>
          <ul>
            <li>Fotografía del Tag (ambos lados)</li>
            <li>Código de activación o QR visible en el Tag</li>
            <li>Lugar/sitio donde lo adquiriste</li>
            <li>Fecha aproximada de compra</li>
            <li>Comprobante de compra (si lo tienes)</li>
          </ul>
        </li>
        <li>
          Nuestro equipo verificará la autenticidad en <strong>2-3 días hábiles</strong> y 
          te confirmará si es un producto oficial
        </li>
      </ol>

      <div className="alert alert-warning mb-0">
        <p className="mb-2">
          <strong>
            <i className="bi bi-shield-check me-2"></i>
            Identificación de Tags Oficiales:
          </strong>
        </p>
        <p className="mb-0 small">
          Todos los Tags oficiales de LemmonTags incluyen:
        </p>
        <ul className="mb-0 small">
          <li>Logo de LemmonTags impreso con alta calidad</li>
          <li>Código QR único registrado en nuestra base de datos</li>
          <li>Chip NFC certificado que redirige a <strong>lemmontags.com</strong></li>
          <li>Empaque oficial con hologramas de seguridad (para compras nuevas)</li>
          <li>Número de serie único en la parte posterior</li>
        </ul>
      </div>
    </div>
  </div>

  <h6 className="fw-bold mt-4">Reporte de Falsificaciones:</h6>
  <p>
    Si encuentras productos falsificados de LemmonTags o vendedores no autorizados que afirman 
    vender productos oficiales, por favor repórtalo a{" "}
    <a href="mailto:legal@lemmontags.com">legal@lemmontags.com</a>. Tu ayuda nos permite proteger a otros 
    usuarios y mantener la integridad de nuestra marca.
  </p>
</section>

      {/* Sección 3 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">3. Cuentas de Usuario y Responsabilidades</h4>
        <p><strong>Elegibilidad:</strong> Debes tener al menos 18 años para crear una cuenta.</p>
        <p>
          <strong>Precisión de la Información:</strong> Te comprometes a proporcionar información 
          precisa, actual y completa durante el proceso de registro y a mantenerla actualizada. Eres 
          el único responsable de la información que publicas en el perfil de tu Tag.
        </p>
        <p>
          <strong>Seguridad de la Cuenta:</strong> Eres responsable de salvaguardar tu contraseña y 
          de cualquier actividad que ocurra en tu cuenta. Notifícanos inmediatamente sobre cualquier 
          uso no autorizado de tu cuenta.
        </p>
        <p>
          <strong>Intransferibilidad:</strong> Tu suscripción y Tags son personales e intransferibles. 
          No puedes ceder, vender o transferir tu cuenta o Tags a otra persona sin autorización 
          escrita de Inqubits S.A. de C.V.
        </p>
      </section>

      {/* Sección 3.5 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">3.5. Requisitos Técnicos Mínimos</h4>
        
        <div className="alert alert-info">
          <h6 className="alert-heading">
            <i className="bi bi-phone me-2"></i>
            Lo Que Necesitas Para Usar LemmonTags
          </h6>
          <p>Al adquirir nuestro servicio, el cliente acepta y confirma que cuenta con:</p>
          <ul className="mb-0">
            <li>
              <strong>Dispositivo móvil</strong> capaz de leer códigos QR y/o tecnología NFC 
              (Near Field Communication)
            </li>
            <li>
              <strong>Conexión a Internet</strong> (datos móviles o WiFi)
            </li>
            <li>
              <strong>Correo electrónico activo y funcional</strong> para registrarse, recibir 
              notificaciones y gestionar su cuenta
            </li>
            <li>
              <strong>Conocimientos básicos</strong> sobre el uso de códigos QR, tecnología NFC 
              y navegación web
            </li>
          </ul>
        </div>

        <div className="alert alert-warning mt-3">
          <p className="mb-2">
            <strong>
              <i className="bi bi-exclamation-triangle me-2"></i>
              Importante - Periodo de Gracia:
            </strong>
          </p>
          <p>
            Durante los primeros <strong>30 días naturales</strong> (periodo de garantía), ofrecemos 
            soporte completo para ayudarte a familiarizarte con el sistema.
          </p>
          <p className="mb-0">
            <strong>Después del periodo de gracia:</strong> El desconocimiento sobre el uso de códigos QR, 
            tecnología NFC, o la falta de correo electrónico <strong>NO será motivo de devolución, 
            reembolso o cancelación del servicio</strong>. Es responsabilidad del usuario asegurarse de 
            contar con los requisitos técnicos necesarios antes de adquirir el producto.
          </p>
        </div>

        <p className="mt-3">
          <strong>Soporte disponible:</strong> Si necesitas ayuda durante tu periodo de gracia, 
          contáctanos en <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>
        </p>
      </section>

     {/* Sección 4 - AMPLIADA CON SEGURIDAD */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">4. Uso Aceptable, Prohibiciones y Seguridad del Sistema</h4>
  
  <p>
    Te comprometes a utilizar el Servicio de manera legal, ética y conforme a estos Términos. 
    <strong> El incumplimiento de estas reglas resultará en la terminación inmediata de tu 
    cuenta sin derecho a reembolso</strong>, además de posibles acciones legales.
  </p>

  <h6 className="fw-bold mt-4">Prohibiciones Generales:</h6>
  <p>Específicamente, te comprometes a NO:</p>
  <ul className="mb-3">
    <li>Publicar información falsa, engañosa o maliciosa</li>
    <li>Acosar, abusar, amenazar o dañar a otra persona a través del canal de comunicación</li>
    <li>Utilizar el Servicio para fines comerciales no autorizados o spam</li>
    <li>Reproducir, duplicar o copiar los Tags físicos sin autorización escrita</li>
    <li>Revender, subarrendar o transferir tu cuenta a terceros</li>
    <li className="text-danger">
      <strong>Usar los Tags para rastrear, localizar o monitorear personas, mascotas u 
      objetos sin el consentimiento explícito y por escrito de su propietario legítimo</strong>
    </li>
    <li className="text-danger">
      <strong>Colocar Tags en propiedad ajena sin autorización con fines de vigilancia 
      o rastreo no autorizado</strong>
    </li>
  </ul>

  <div className="alert alert-danger mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-shield-exclamation me-2"></i>
      Prohibiciones de Seguridad y Técnicas (Violaciones Graves)
    </h6>
    <p className="mb-3">
      <strong>Las siguientes actividades constituyen violaciones GRAVES</strong> y resultarán 
      en terminación inmediata de la cuenta, sin reembolso, y potencial acción legal:
    </p>
    
    <h6 className="fw-bold text-danger mb-2">Ataques y Acceso No Autorizado:</h6>
    <ul className="mb-3">
      <li>
        <strong>Hackeo o intrusión:</strong> Intentar acceder sin autorización a nuestros 
        servidores, bases de datos, sistemas, redes o cuentas de otros usuarios
      </li>
      <li>
        <strong>Ataques de denegación de servicio (DDoS):</strong> Sobrecargar intencionalmente 
        nuestros servidores o infraestructura
      </li>
      <li>
        <strong>Explotación de vulnerabilidades:</strong> Explotar bugs, vulnerabilidades de 
        seguridad o errores del sistema sin reportarlos de manera responsable
      </li>
      <li>
        <strong>Phishing o suplantación:</strong> Crear sitios web, emails o mensajes falsos 
        que suplantan la identidad de LemmonTags
      </li>
      <li>
        <strong>Inyección de código:</strong> SQL injection, XSS, o cualquier forma de 
        inyección de código malicioso
      </li>
      <li>
        <strong>Robo de credenciales:</strong> Intentar obtener contraseñas, tokens de acceso 
        o información de autenticación de otros usuarios
      </li>
    </ul>

    <h6 className="fw-bold text-danger mb-2">Ingeniería Inversa y Manipulación:</h6>
    <ul className="mb-3">
      <li>
        <strong>Ingeniería inversa:</strong> Descompilar, desensamblar o realizar ingeniería 
        inversa de nuestro software, aplicaciones móviles, APIs o Tags NFC
      </li>
      <li>
        <strong>Clonación de Tags:</strong> Duplicar, clonar o copiar el contenido de los 
        chips NFC de los Tags para crear réplicas no autorizadas
      </li>
      <li>
        <strong>Modificación de firmware:</strong> Alterar, modificar o reprogramar los chips 
        NFC o códigos QR de los Tags
      </li>
      <li>
        <strong>Scraping no autorizado:</strong> Extraer datos masivos de nuestra plataforma 
        mediante bots, scrapers o herramientas automatizadas
      </li>
      <li>
        <strong>Bypass de seguridad:</strong> Eludir, desactivar o manipular cualquier medida 
        de seguridad, autenticación o control de acceso
      </li>
    </ul>

    <h6 className="fw-bold text-danger mb-2">Mal Uso del Sistema:</h6>
    <ul className="mb-0">
      <li>
        <strong>Automatización no autorizada:</strong> Usar bots, scripts o herramientas 
        automatizadas para interactuar con el Servicio sin permiso expreso
      </li>
      <li>
        <strong>Creación de cuentas múltiples:</strong> Crear cuentas falsas, duplicadas o 
        múltiples para abusar del sistema, promociones o garantías
      </li>
      <li>
        <strong>Interferencia con otros usuarios:</strong> Interrumpir, degradar o interferir 
        con la experiencia de otros usuarios del Servicio
      </li>
      <li>
        <strong>Distribución de malware:</strong> Subir, distribuir o propagar virus, malware, 
        ransomware o cualquier código malicioso
      </li>
    </ul>
  </div>

  <div className="alert alert-dark mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-gavel me-2"></i>
      Consecuencias Legales y Acciones Judiciales
    </h6>
    <p className="mb-3">
      <strong>Inqubits S.A. de C.V. se reserva el derecho</strong> de ejercer todas las acciones 
      legales disponibles, tanto civiles como penales, contra usuarios que violen estas prohibiciones, 
      incluyendo pero no limitado a:
    </p>
    
    <div className="row">
      <div className="col-md-6 mb-3">
        <h6 className="text-danger mb-2">Acciones Administrativas:</h6>
        <ul className="small mb-0">
          <li>Terminación inmediata de cuenta sin reembolso</li>
          <li>Bloqueo permanente de IP y dispositivos</li>
          <li>Inhabilitación de Tags vinculados a la cuenta</li>
          <li>Inclusión en lista negra de usuarios prohibidos</li>
        </ul>
      </div>
      <div className="col-md-6 mb-3">
        <h6 className="text-danger mb-2">Acciones Legales:</h6>
        <ul className="small mb-0">
          <li>Denuncia penal ante la Fiscalía General</li>
          <li>Demanda civil por daños y perjuicios</li>
          <li>Recuperación de costos legales y forenses</li>
          <li>Cooperación con autoridades (Policía Cibernética, FBI, Interpol)</li>
        </ul>
      </div>
    </div>

    <p className="mb-2 mt-3">
      <strong>Marco Legal Aplicable en México:</strong>
    </p>
    <ul className="small mb-0">
      <li>
        <strong>Código Penal Federal - Artículo 211 bis:</strong> Acceso ilícito a sistemas 
        informáticos (prisión de 6 meses a 4 años)
      </li>
      <li>
        <strong>Artículo 211 bis 1:</strong> Modificación, destrucción o provocación de pérdida 
        de información (prisión de 6 meses a 2 años)
      </li>
      <li>
        <strong>Artículo 211 bis 2:</strong> Daño a sistemas informáticos (prisión de 1 a 4 años)
      </li>
      <li>
        <strong>Ley Federal de Protección de Datos:</strong> Uso indebido de datos personales
      </li>
      <li>
        <strong>Código Civil:</strong> Responsabilidad por daños y perjuicios
      </li>
    </ul>
  </div>

  <div className="card border-info">
    <div className="card-header bg-info text-white">
      <strong>
        <i className="bi bi-bug me-2"></i>
        Programa de Divulgación Responsable de Vulnerabilidades
      </strong>
    </div>
    <div className="card-body">
      <p>
        <strong>Si descubres una vulnerabilidad de seguridad de manera legítima</strong>, 
        te alentamos a reportarla de forma responsable en lugar de explotarla.
      </p>
      <p className="mb-2"><strong>Cómo reportar vulnerabilidades de forma segura:</strong></p>
      <ol className="mb-3">
        <li>
          Envía un correo a <a href="mailto:security@lemmontags.com">security@lemmontags.com</a> con:
          <ul>
            <li>Descripción detallada de la vulnerabilidad</li>
            <li>Pasos para reproducirla</li>
            <li>Impacto potencial</li>
            <li>Evidencia (capturas de pantalla, logs)</li>
          </ul>
        </li>
        <li>
          <strong>NO explotes la vulnerabilidad</strong> ni accedas a datos de otros usuarios
        </li>
        <li>Danos tiempo razonable (30-90 días) para corregir el problema antes de divulgarlo públicamente</li>
        <li>Actúa de buena fe y dentro de los límites de la ley</li>
      </ol>
      <p className="mb-0">
        <strong>Protección para investigadores de seguridad:</strong> Si sigues este proceso, 
        NO ejerceremos acciones legales en tu contra y reconoceremos públicamente tu contribución 
        (si lo deseas).
      </p>
    </div>
  </div>

  <div className="alert alert-warning mt-4 mb-0">
    <h6 className="mb-2">
      <i className="bi bi-exclamation-triangle me-2"></i>
      Cooperación con Autoridades
    </h6>
    <p className="mb-0">
      <strong>LemmonTags coopera plenamente con las autoridades</strong> en investigaciones 
      relacionadas con delitos informáticos, uso indebido del servicio o violaciones de privacidad. 
      Proporcionaremos logs, registros de actividad, direcciones IP, y toda la información técnica 
      necesaria para apoyar investigaciones legales.
    </p>
  </div>
</section>

     {/* Sección 5 - ACTUALIZADA */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">5. Propiedad Intelectual y Contenido del Usuario</h4>
  
  <h6 className="fw-bold">Nuestra Propiedad Intelectual:</h6>
  <p>
    Todo el contenido del Servicio, incluyendo pero no limitado a textos, gráficos, logos, 
    íconos, imágenes y software, es propiedad de LemmonTags o de sus licenciantes y está 
    protegido por las leyes de derechos de autor y marcas registradas. No se te otorga ninguna 
    licencia o derecho sobre nuestra propiedad intelectual, excepto para el uso personal y no 
    comercial del Servicio.
  </p>

  <h6 className="fw-bold mt-4">Contenido Subido por el Usuario:</h6>
  <p>
    Al subir contenido a nuestra plataforma (fotografías de mascotas, descripciones, etc.), 
    <strong> tú conservas todos los derechos de propiedad sobre ese contenido</strong>. Sin embargo:
  </p>
  <ul className="mb-3">
    <li>
      Nos otorgas una <strong>licencia no exclusiva, mundial, libre de regalías y transferible</strong> para 
      usar, reproducir, modificar, adaptar, publicar y mostrar dicho contenido únicamente para 
      los fines de operar y mejorar el Servicio.
    </li>
    <li>
      Esta licencia incluye el derecho de mostrar las fotografías y descripciones de tu mascota 
      en el perfil público del Tag cuando lo actives en "modo perdido".
    </li>
    <li>
      Garantizas que tienes todos los derechos necesarios para otorgarnos esta licencia y que 
      el contenido no infringe derechos de terceros.
    </li>
  </ul>

  <div className="alert alert-warning">
    <p className="mb-2">
      <strong>
        <i className="bi bi-camera me-2"></i>
        Importante sobre Fotografías:
      </strong>
    </p>
    <p className="mb-0">
      Solo sube fotografías de las que seas propietario o tengas permiso para usar. NO subas 
      fotografías de terceros, contenido con derechos de autor, o imágenes inapropiadas. 
      Nos reservamos el derecho de eliminar cualquier contenido que viole estos términos.
    </p>
  </div>
</section>

      {/* Sección 6 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">6. Limitación de Responsabilidad</h4>
        
        <div className="alert alert-danger">
          <h6 className="alert-heading">
            <i className="bi bi-shield-exclamation me-2"></i>
            Limitaciones Importantes
          </h6>
          <p>
            <strong>Inqubits S.A. de C.V.</strong> (LemmonTags) NO garantiza la recuperación de ninguna 
            mascota u objeto. Nuestro Servicio actúa como un facilitador tecnológico.
          </p>
          <p>
            <strong>NO seremos responsables</strong> por daños directos, indirectos, incidentales, 
            especiales o consecuentes que resulten de:
          </p>
          <ul className="mb-3">
            <li>El uso o la incapacidad de usar nuestro Servicio</li>
            <li>La pérdida, daño o no recuperación de una mascota u objeto</li>
            <li>Mal uso del Tag o de la información proporcionada</li>
            <li>Interacciones entre el Titular y el Localizador</li>
            <li>Fallas en el sistema, interrupciones del servicio o pérdida de datos</li>
          </ul>
          <p className="mb-0">
            <strong>Límite máximo de responsabilidad:</strong> En ningún caso nuestra responsabilidad 
            total excederá el monto pagado por el cliente por el producto o servicio específico que 
            dio origen al reclamo.
          </p>
        </div>

        <p className="mt-3">
          La interacción entre el Titular y el Localizador es responsabilidad exclusiva de ambas partes. 
          LemmonTags no participa en estas interacciones ni asume responsabilidad por las mismas.
        </p>
      </section>

      {/* Sección 7 */}
     <section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">7. Disponibilidad del Servicio y Fuerza Mayor</h4>
  
  <h6 className="fw-bold">Disponibilidad del Servicio:</h6>
  <p>
    Nos esforzamos por mantener el Servicio disponible de manera continua. Sin embargo, 
    <strong> no garantizamos disponibilidad del 100%</strong>.
  </p>
  <p>
    El Servicio puede experimentar interrupciones temporales (downtime) derivadas de:
  </p>
  <ul className="mb-3">
    <li>Mantenimiento programado o de emergencia</li>
    <li>
      <strong>Servicios de terceros:</strong> Dependemos de proveedores como Amazon Web Services 
      (AWS), Google Cloud Platform y otros servicios de infraestructura. Cualquier interrupción 
      en estos servicios externos puede afectar la disponibilidad de nuestra plataforma, de 
      acuerdo con las políticas y acuerdos de nivel de servicio (SLA) de dichos proveedores.
    </li>
    <li>Actualizaciones de seguridad críticas</li>
    <li>Fallos técnicos imprevistos en hardware o software</li>
  </ul>

  <h6 className="fw-bold mt-4">Eventos de Fuerza Mayor:</h6>
  <p>
    Conforme a lo establecido en el Artículo 2111 del Código Civil Federal y el Artículo 92 
    de la Ley Federal de Protección al Consumidor, <strong>Inqubits S.A. de C.V. no será 
    responsable</strong> por el incumplimiento total o parcial de sus obligaciones cuando 
    éstas sean impedidas o demoradas por eventos de fuerza mayor, caso fortuito, o cualquier 
    otra causa fuera de nuestro control razonable, incluyendo pero no limitado a:
  </p>

  <div className="card mb-3">
    <div className="card-header bg-warning text-dark">
      <strong>
        <i className="bi bi-exclamation-triangle me-2"></i>
        Eventos que Constituyen Fuerza Mayor
      </strong>
    </div>
    <div className="card-body">
      <div className="row">
        <div className="col-md-6">
          <h6 className="fw-bold">Desastres Naturales:</h6>
          <ul className="small mb-3">
            <li>Terremotos, huracanes, inundaciones</li>
            <li>Incendios forestales o naturales</li>
            <li>Erupciones volcánicas</li>
            <li>Tsunamis o maremotos</li>
          </ul>
        </div>
        <div className="col-md-6">
          <h6 className="fw-bold">Eventos Sociales y Políticos:</h6>
          <ul className="small mb-3">
            <li>Guerras, invasiones, actos terroristas</li>
            <li>Disturbios civiles, huelgas nacionales</li>
            <li>Embargos o bloqueos</li>
            <li>Actos de autoridad gubernamental</li>
          </ul>
        </div>
        <div className="col-md-6">
          <h6 className="fw-bold">Eventos de Salud Pública:</h6>
          <ul className="small mb-3">
            <li>Pandemias, epidemias</li>
            <li>Cuarentenas obligatorias</li>
            <li>Emergencias sanitarias declaradas</li>
          </ul>
        </div>
        <div className="col-md-6">
          <h6 className="fw-bold">Eventos Tecnológicos:</h6>
          <ul className="small mb-3">
            <li>Ciberataques masivos (DDoS, ransomware)</li>
            <li>Fallas en infraestructura de Internet global</li>
            <li>Apagones eléctricos regionales o nacionales</li>
            <li>Fallas catastróficas de proveedores (AWS, Google)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div className="alert alert-danger mb-3">
    <h6 className="mb-3">
      <i className="bi bi-shield-exclamation me-2"></i>
      Efectos de Fuerza Mayor
    </h6>
    <p>En caso de un evento de fuerza mayor:</p>
    <ul className="mb-3">
      <li>
        <strong>Suspensión de Obligaciones:</strong> Nuestras obligaciones quedarán suspendidas 
        durante el tiempo que dure el evento y sus efectos directos.
      </li>
      <li>
        <strong>Sin Responsabilidad:</strong> No seremos responsables por daños, pérdidas, 
        perjuicios o lucro cesante derivados del incumplimiento causado por fuerza mayor.
      </li>
      <li>
        <strong>Sin Penalizaciones:</strong> No aplicarán penalizaciones, multas o sanciones 
        por incumplimiento durante el evento.
      </li>
      <li>
        <strong>Notificación:</strong> Te notificaremos sobre el evento de fuerza mayor y 
        su duración estimada a través de correo electrónico o en nuestro sitio web.
      </li>
    </ul>
    <p className="mb-0">
      <strong>Compensación Opcional:</strong> A nuestra discreción, podemos extender tu 
      suscripción de forma proporcional al tiempo de interrupción causado por fuerza mayor 
      (e.g., si el servicio estuvo inactivo 7 días, extendemos tu suscripción 7 días).
    </p>
  </div>

  <h6 className="fw-bold mt-4">Terminación por Fuerza Mayor Prolongada:</h6>
  <p>
    Si un evento de fuerza mayor se extiende por más de <strong>60 días naturales continuos</strong>, 
    tanto tú como nosotros podremos terminar el contrato sin penalización. En tal caso:
  </p>
  <ul className="mb-3">
    <li>Se realizará un reembolso proporcional del tiempo restante no utilizado</li>
    <li>Tus datos se conservarán conforme a nuestra política de conservación (Sección 10)</li>
    <li>Podrás reactivar el servicio una vez superado el evento sin costo adicional (si aplica)</li>
  </ul>

  <p>
    <strong>LemmonTags no se hace responsable</strong> por interrupciones del servicio causadas 
    por terceros, eventos de fuerza mayor o cualquier circunstancia fuera de nuestro control razonable.
  </p>
</section>

      {/* Sección 8 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">8. Modificaciones a los Términos</h4>
        <p>
          Nos reservamos el derecho de modificar estos Términos en cualquier momento. Si realizamos 
          cambios, te notificaremos publicando los términos actualizados en la Plataforma o mediante 
          un correo electrónico. El uso continuado del Servicio después de la notificación constituirá 
          tu aceptación de los nuevos términos.
        </p>
      </section>

      {/* Sección 9 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">9. Ley Aplicable y Jurisdicción</h4>
        <p>
          Estos Términos se regirán e interpretarán de acuerdo con las leyes de los Estados Unidos 
          Mexicanos. Cualquier disputa que surja en relación con estos Términos se someterá a la 
          jurisdicción exclusiva de los tribunales competentes de la Ciudad de México.
        </p>
      </section>

      {/* Sección 10 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">10. Conservación de Información y Reactivación</h4>
        <p>
          Una vez concluido el periodo de suscripción, la información del usuario permanecerá 
          almacenada en nuestro sistema por un periodo máximo de <strong>6 meses</strong>. Durante 
          este tiempo, el usuario podrá reactivar su servicio y recuperar sus datos previos.
        </p>
        <p>
          Transcurrido ese plazo, <strong>la información será eliminada de forma definitiva</strong> 
          y no podrá ser restaurada.
        </p>
      </section>

      {/* Sección 11 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">11. Renovación del Servicio y Descuentos</h4>
        
        <div className="card mb-3">
          <div className="card-header bg-primary text-white">
            <strong>
              <i className="bi bi-arrow-repeat me-2"></i>
              Sistema de Renovación Anual
            </strong>
          </div>
          <div className="card-body">
            <p>
              LemmonTags <strong>NO cuenta con renovación automática</strong>. Cada año, el usuario 
              deberá renovar manualmente su suscripción para continuar disfrutando del servicio.
            </p>
            
            <h6 className="fw-bold mt-3">Opciones de Renovación:</h6>
            <ul className="mb-3">
              <li>A través de nuestra tienda en línea: <a href="https://lemmontags.com">lemmontags.com</a></li>
              <li>Mediante transferencia bancaria (contactando a un vendedor autorizado)</li>
              <li>Por correo electrónico: <a href="mailto:ventas@lemmontags.com">ventas@lemmontags.com</a></li>
            </ul>

            <p className="mb-0 small text-muted">
              <strong>Recordatorio:</strong> Te enviaremos notificaciones por correo electrónico 
              30, 15 y 7 días antes del vencimiento de tu suscripción.
            </p>
          </div>
        </div>

        <div className="card border-success">
          <div className="card-header bg-success text-white">
            <strong>
              <i className="bi bi-gift me-2"></i>
              Programa de Renovación Anticipada
            </strong>
          </div>
          <div className="card-body">
            <p>
              <strong>¡Ahorra renovando antes!</strong> Premiamos la lealtad de nuestros usuarios 
              con descuentos especiales por renovación anticipada.
            </p>
            
            <h6 className="fw-bold">Descuentos Por Renovación Anticipada:</h6>
            <table className="table table-sm table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Si Renuevas...</th>
                  <th>Descuento</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>30+ días antes del vencimiento</td>
                  <td className="text-success fw-bold">15% de descuento</td>
                </tr>
                <tr>
                  <td>15-29 días antes del vencimiento</td>
                  <td className="text-success fw-bold">10% de descuento</td>
                </tr>
                <tr>
                  <td>7-14 días antes del vencimiento</td>
                  <td className="text-success fw-bold">5% de descuento</td>
                </tr>
                <tr>
                  <td>Después del vencimiento</td>
                  <td className="text-muted">Sin descuento (precio regular)</td>
                </tr>
              </tbody>
            </table>

            <div className="alert alert-info mb-0 mt-3">
              <p className="mb-2">
                <strong>
                  <i className="bi bi-calendar-check me-2"></i>
                  ¿Cómo Funciona?
                </strong>
              </p>
              <ol className="mb-0">
                <li>Recibirás un recordatorio por correo con tu código de descuento</li>
                <li>Ingresa al sitio web y renueva usando tu código</li>
                <li>El descuento se aplica automáticamente</li>
                <li>Tu suscripción se extiende por un año más desde la fecha de renovación</li>
              </ol>
            </div>
          </div>
        </div>

        <p className="mt-3">
          <strong>Nota importante:</strong> Si no renuevas dentro de los 6 meses posteriores al 
          vencimiento, tu información será eliminada de forma definitiva de acuerdo con nuestra 
          política de conservación de datos (ver Sección 10).
        </p>
      </section>

      {/* Sección 12 - CORREGIDA */}
      <section className="mb-5" id="seccion-devolucion">
        <h4 className="border-bottom pb-2 mb-3">12. Garantía de Satisfacción y Política de Reembolso</h4>
        
        <div className="card border-success mb-4">
          <div className="card-header bg-success text-white">
            <strong>
              <i className="bi bi-shield-check me-2"></i>
              Garantía de Satisfacción 100% - 30 Días
            </strong>
          </div>
          <div className="card-body">
            <p>
              LemmonTags ofrece una garantía de satisfacción de <strong>30 días naturales</strong> a 
              partir de la fecha de compra. Si no estás satisfecho por <strong>cualquier motivo</strong>, 
              puedes solicitar una devolución, incluyendo (pero no limitado a):
            </p>
            <ul className="mb-3">
              <li>No estás de acuerdo con nuestros Términos de Servicio</li>
              <li>No estás de acuerdo con nuestro Aviso de Privacidad o tratamiento de datos</li>
              <li>El producto no cumplió tus expectativas</li>
              <li>No te gustó el diseño, funcionalidad o calidad</li>
              <li>Cualquier otra razón</li>
            </ul>

            <h6 className="fw-bold text-success mb-3">Condiciones para Reembolso:</h6>
            
            <div className="row">
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-2 mt-1"></i>
                  <div>
                    <strong>Plazo:</strong> Dentro de los primeros 30 días naturales desde la compra
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-2 mt-1"></i>
                  <div>
                    <strong>Reembolso:</strong> 100% del precio del producto
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-x-circle-fill text-danger me-2 mt-1"></i>
                  <div>
                    <strong>Envío original:</strong> NO reembolsable
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-x-circle-fill text-danger me-2 mt-1"></i>
                  <div>
                    <strong>Envío de devolución:</strong> El cliente lo cubre
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-2 mt-1"></i>
                  <div>
                    <strong>Condición:</strong> Tag en buenas condiciones
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle-fill text-success me-2 mt-1"></i>
                  <div>
                    <strong>Justificación:</strong> No es necesaria (opcional)
                  </div>
                </div>
              </div>
            </div>

            <div className="alert alert-warning mt-3 mb-3">
              <p className="mb-2">
                <strong>
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  Después de los 30 días:
                </strong>
              </p>
              <p className="mb-0">
                <strong>NO se realizan reembolsos bajo ninguna circunstancia</strong>, salvo 
                defectos de fabricación cubiertos por garantía (ver Sección 13 - Reposición de Tags).
              </p>
            </div>

            <div className="alert alert-info mb-0">
              <p className="mb-2">
                <strong>
                  <i className="bi bi-envelope me-2"></i>
                  ¿Cómo Solicitar tu Devolución?
                </strong>
              </p>
              <ol className="mb-0">
                <li>Envía un correo a <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a></li>
                <li>Asunto: "Solicitud de devolución"</li>
                <li>Incluye: Tu número de orden</li>
                <li>Opcionalmente: Motivo de devolución (nos ayuda a mejorar)</li>
                <li>Te responderemos con la dirección para enviar el producto</li>
                <li>Envía el Tag en buenas condiciones</li>
                <li>Una vez recibido y verificado, procesaremos tu reembolso en <strong>5-10 días hábiles</strong></li>
              </ol>
            </div>
          </div>
        </div>

        <div className="card bg-light">
          <div className="card-body">
            <h6 className="fw-bold mb-3">
              <i className="bi bi-calculator me-2"></i>
              Ejemplo de Reembolso:
            </h6>
            <div className="row">
              <div className="col-md-6">
                <p className="mb-1"><strong>Compra inicial:</strong></p>
                <ul className="mb-3">
                  <li>Precio del Tag: $500</li>
                  <li>Envío: $150</li>
                  <li><strong>Total pagado: $650</strong></li>
                </ul>
              </div>
              <div className="col-md-6">
                <p className="mb-1"><strong>Reembolso (dentro de 30 días):</strong></p>
                <ul className="mb-3">
                  <li>Reembolso del Tag: $500 ✅</li>
                  <li>Envío original: $0 ❌</li>
                  <li>Envío de devolución: ~$150 (tú pagas) ❌</li>
                  <li><strong>Total recuperado: $500</strong></li>
                </ul>
              </div>
            </div>
            <p className="mb-0 small text-muted">
              <strong>Nota:</strong> Los gastos de envío son costos operativos devengados al momento 
              del despacho (paquetería, embalaje, gestión logística) y por tanto no son reembolsables, 
              conforme a las prácticas estándar del comercio electrónico.
            </p>
          </div>
        </div>
      </section>

      
      {/* Sección 13 - AMPLIADA CON GARANTÍA DE HARDWARE */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">13. Reposición de Tags y Garantía de Hardware</h4>
  
  <div className="alert alert-success mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-shield-check me-2"></i>
      Garantía de Hardware - 12 Meses
    </h6>
    <p>
      Todos los Tags físicos de LemmonTags incluyen una <strong>garantía de hardware de 
      12 meses</strong> a partir de la fecha de compra, que cubre únicamente <strong>defectos 
      de fabricación</strong> en condiciones normales de uso.
    </p>
  </div>

  <h6 className="fw-bold">¿Qué Cubre la Garantía?</h6>
  <p>La garantía de hardware cubre <strong>exclusivamente</strong> los siguientes defectos de fabricación:</p>
  <ul className="mb-3">
    <li>
      <strong>Falla del chip NFC:</strong> El chip NFC no es detectado por dispositivos compatibles 
      desde el momento de la compra o deja de funcionar sin causa aparente
    </li>
    <li>
      <strong>Código QR ilegible:</strong> El código QR impreso es ilegible debido a defectos 
      de impresión (no por desgaste o daño físico)
    </li>
    <li>
      <strong>Desprendimiento de materiales:</strong> Adhesivo, recubrimiento o materiales 
      del Tag se desprenden en condiciones normales de uso dentro del primer mes
    </li>
    <li>
      <strong>Error en código de activación:</strong> El código de activación único del Tag 
      no es reconocido por el sistema (muy poco común)
    </li>
  </ul>

  <div className="card border-danger mb-4">
    <div className="card-header bg-danger text-white">
      <strong>
        <i className="bi bi-x-circle me-2"></i>
        ¿Qué NO Cubre la Garantía?
      </strong>
    </div>
    <div className="card-body">
      <p className="mb-2">
        <strong>La garantía NO cubre</strong> daños causados por:
      </p>

      <div className="row">
        <div className="col-md-6">
          <h6 className="text-danger small fw-bold mb-2">Daños Físicos:</h6>
          <ul className="small mb-3">
            <li><strong>Daño por agua o humedad</strong> (el Tag no es resistente al agua)</li>
            <li><strong>Mordidas, arañazos o daños por mascotas</strong></li>
            <li><strong>Golpes, caídas o impactos</strong> que dañen el Tag</li>
            <li><strong>Exposición a temperaturas extremas</strong> (menor a 0°C o mayores a 60°C prolongado)</li>
            <li><strong>Perforación, doblado o deformación</strong> física del Tag</li>
            <li><strong>Exposición a productos químicos</strong> o sustancias corrosivas</li>
          </ul>
        </div>
        <div className="col-md-6">
          <h6 className="text-danger small fw-bold mb-2">Mal Uso:</h6>
          <ul className="small mb-3">
            <li><strong>Instalación incorrecta</strong> que dañe el Tag</li>
            <li><strong>Uso en condiciones no recomendadas</strong> (ej: bajo el agua)</li>
            <li><strong>Manipulación o modificación</strong> del hardware del Tag</li>
            <li><strong>Intento de reprogramación</strong> del chip NFC</li>
            <li><strong>Desgaste por uso extremo</strong> o inapropiado</li>
            <li><strong>Pérdida, robo o extravío</strong> del Tag</li>
          </ul>
        </div>
      </div>

      <h6 className="text-danger small fw-bold mb-2 mt-2">Desgaste Normal:</h6>
      <ul className="small mb-0">
        <li><strong>Decoloración o desvanecimiento</strong> del QR por exposición solar prolongada</li>
        <li><strong>Desgaste estético</strong> (rayones superficiales, pérdida de brillo)</li>
        <li><strong>Adhesivo que pierde efectividad</strong> después de múltiples usos o por tiempo prolongado</li>
        <li><strong>Deterioro por uso normal</strong> durante más de 12 meses</li>
      </ul>
    </div>
  </div>

  <h6 className="fw-bold mt-4">Reposición de Tags por Garantía:</h6>
  <p>
    Como parte de nuestro compromiso con la calidad, ofrecemos <strong>una (1) reposición de 
    Tag sin costo del producto</strong> por año de suscripción activa, aplicable a:
  </p>
  <ul className="mb-3">
    <li><strong>Defecto de fabricación</strong> comprobado dentro de los 12 meses</li>
    <li><strong>Falla técnica del chip NFC o QR</strong> sin daño físico visible</li>
    <li><strong>Primera reposición por pérdida o extravío</strong> (en los primeros 12 meses)</li>
  </ul>

  <div className="alert alert-info">
    <p className="mb-2">
      <strong>Condiciones de Reposición Gratuita:</strong>
    </p>
    <ul className="mb-0">
      <li>Máximo <strong>una (1) reposición gratuita por año</strong> de suscripción activa</li>
      <li>El usuario debe cubrir los <strong>gastos de envío</strong> del Tag de reposición</li>
      <li>La suscripción debe estar <strong>activa</strong> al momento de la solicitud</li>
      <li>
        Para defectos de fabricación: Debes devolver el Tag defectuoso (envío pagado por nosotros 
        si es defecto comprobado)
      </li>
      <li>
        Reposiciones adicionales tienen un costo de <strong>$150 MXN</strong> más envío
      </li>
    </ul>
  </div>

  <h6 className="fw-bold mt-4">Proceso para Solicitar Reposición:</h6>
  <ol className="mb-3">
    <li>
      Contacta a <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a> con:
      <ul>
        <li>Número de orden o código de activación del Tag</li>
        <li>Descripción del problema</li>
        <li>Fotografías del Tag (ambos lados) mostrando el daño o defecto</li>
        <li>Fecha aproximada de compra</li>
      </ul>
    </li>
    <li>
      Nuestro equipo evaluará si aplica la garantía (<strong>2-3 días hábiles</strong>)
    </li>
    <li>
      Si aplica: Te enviaremos una guía prepagada para devolución (si es defecto de fabricación) 
      o procesaremos el envío del Tag de reposición
    </li>
    <li>
      Recibirás el nuevo Tag en <strong>5-10 días hábiles</strong> después de la aprobación
    </li>
    <li>
      El nuevo Tag tendrá un código único diferente; deberás activarlo desde tu panel
    </li>
  </ol>

  <h6 className="fw-bold mt-4">Limitaciones Técnicas del Hardware:</h6>
  
  <div className="alert alert-warning mb-0">
    <h6 className="mb-3">
      <i className="bi bi-info-circle me-2"></i>
      Importante: Factores Externos que Afectan el Funcionamiento
    </h6>
    <p>
      El rendimiento de los Tags NFC/QR <strong>depende de factores externos</strong> fuera 
      de nuestro control:
    </p>
    
    <h6 className="small fw-bold mb-2">Compatibilidad de Dispositivos:</h6>
    <ul className="small mb-3">
      <li>
        <strong>No todos los dispositivos tienen NFC:</strong> Algunos smartphones, especialmente 
        modelos antiguos o de gama baja, no incluyen chip NFC
      </li>
      <li>
        <strong>NFC desactivado:</strong> El usuario debe tener NFC activado en su dispositivo
      </li>
      <li>
        <strong>Carcasas gruesas:</strong> Fundas o carcasas metálicas pueden bloquear la señal NFC
      </li>
      <li>
        <strong>Distancia de lectura:</strong> NFC requiere contacto o proximidad inmediata (menor a 4cm)
      </li>
    </ul>

    <h6 className="small fw-bold mb-2">Factores Ambientales:</h6>
    <ul className="small mb-3">
      <li>
        <strong>Iluminación para QR:</strong> Códigos QR requieren luz adecuada para ser escaneados
      </li>
      <li>
        <strong>Interferencia electromagnética:</strong> Campos magnéticos fuertes pueden afectar NFC
      </li>
      <li>
        <strong>Suciedad o humedad:</strong> Pueden dificultar la lectura del QR o NFC
      </li>
    </ul>

    <p className="mb-0">
      <strong>No nos hacemos responsables</strong> por problemas de lectura causados por 
      incompatibilidad de dispositivos, configuración incorrecta del usuario, o factores ambientales.
    </p>
  </div>
</section>

      {/* Sección 14 */}
      <section className="mb-5">
        <h4 className="border-bottom pb-2 mb-3">14. Comunicaciones y Boletines</h4>
        <p>
          El sistema puede enviar <strong>mensajes de felicitación personalizados</strong> en fechas 
          especiales del dueño o la mascota, siempre que el usuario haya proporcionado esta información 
          en su perfil.
        </p>
        <p>
          Asimismo, el usuario podrá recibir un <strong>boletín mensual</strong> con información 
          relacionada con el cuidado de mascotas, estadísticas de uso de su Tag, consejos de seguridad, 
          o temas personalizados de acuerdo con sus intereses.
        </p>
        <p>
          Este boletín es opcional y puede ser desactivado en cualquier momento desde el{" "}
          <strong>panel del usuario</strong> o haciendo clic en el enlace de "Cancelar suscripción" 
          incluido en cada email.
        </p>
      </section>

      <section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">15. Pagos, Facturación y Métodos de Pago</h4>
  
  <h6 className="fw-bold">Métodos de Pago Aceptados:</h6>
  <ul className="mb-3">
    <li>Tarjetas de crédito y débito (Visa, Mastercard, American Express)</li>
    <li>Transferencia bancaria (SPEI)</li>
    <li>Depósito en tiendas de conveniencia (OXXO, 7-Eleven)</li>
    <li>Plataformas de pago (MercadoPago, PayPal)</li>
  </ul>

  <div className="alert alert-info mb-3">
    <h6 className="mb-2">
      <i className="bi bi-receipt me-2"></i>
      Facturación Fiscal (CFDI)
    </h6>
    <p className="mb-0">
      De acuerdo con las disposiciones del SAT, <strong>todos los pagos incluyen IVA</strong> 
      (16%). Puedes solicitar tu factura fiscal (CFDI) dentro de los primeros <strong>30 días 
      naturales</strong> posteriores a tu compra enviando un correo a{" "}
      <a href="mailto:facturacion@lemmontags.com">facturacion@lemmontags.com</a> con tu RFC y constancia 
      de situación fiscal.
    </p>
  </div>

  <h6 className="fw-bold mt-4">Precios y Moneda:</h6>
  <ul className="mb-3">
    <li>Todos los precios están expresados en <strong>Pesos Mexicanos (MXN)</strong></li>
    <li>Los precios incluyen IVA</li>
    <li>Los precios pueden cambiar sin previo aviso, pero no afectan compras ya realizadas</li>
    <li>Las promociones y descuentos tienen vigencia limitada y condiciones específicas</li>
  </ul>

  <h6 className="fw-bold mt-4">Política de No Renovación Automática:</h6>
  <p>
    LemmonTags <strong>NO realiza cargos automáticos</strong> a tu tarjeta. Cada renovación 
    debe ser autorizada manualmente por el usuario. No guardamos información de tarjetas de 
    crédito en nuestros servidores.
  </p>

  <h6 className="fw-bold mt-4">Errores en el Cobro:</h6>
  <p>
    Si detectas un error en tu cobro (doble cargo, monto incorrecto, etc.), tienes 
    <strong> 60 días naturales</strong> para reportarlo a{" "}
    <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>. Investigaremos y, de 
    confirmarse el error, realizaremos el reembolso en un plazo de 10-15 días hábiles.
  </p>

  <div className="alert alert-warning mb-0">
    <p className="mb-2">
      <strong>
        <i className="bi bi-exclamation-triangle me-2"></i>
        Importante:
      </strong>
    </p>
    <p className="mb-0">
      Una vez procesado el pago, el acceso al servicio se activa inmediatamente. Los reembolsos 
      por arrepentimiento de compra están sujetos a nuestra Política de Garantía de Satisfacción 
      (ver Sección 12).
    </p>
  </div>
</section>
{/* Agregar al final de Sección 15 */}

<h6 className="fw-bold mt-4">Canales de Compra Autorizados:</h6>
<div className="alert alert-info mb-3">
  <p className="mb-2">
    <strong>
      <i className="bi bi-cart-check me-2"></i>
      ¿Dónde Comprar Productos Oficiales?
    </strong>
  </p>
  <p className="mb-0">
    Los productos de LemmonTags solo están disponibles en:
  </p>
  <ol className="mb-0">
    <li>
      <strong>Tienda oficial:</strong>{" "}
      <a href="https://lemmontags.com">https://lemmontags.com</a> (PrestaShop)
    </li>
    <li>
      <strong>Puntos de venta autorizados:</strong> Ver lista en{" "}
      <a href="https://lemmontags.com/puntos-de-venta">lemmontags.com/puntos-de-venta</a>
    </li>
  </ol>
</div>

<div className="alert alert-danger">
  <p className="mb-2">
    <strong>
      <i className="bi bi-exclamation-triangle me-2"></i>
      Compras en Sitios No Oficiales:
    </strong>
  </p>
  <p className="mb-0">
    Cualquier compra realizada en sitios web o tiendas NO listadas oficialmente se considera 
    NO AUTORIZADA. <strong>No ofrecemos garantía, soporte ni reembolsos</strong> para productos 
    adquiridos en canales no oficiales. Si tienes dudas sobre la autenticidad de tu producto, 
    contacta: <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>
  </p>
</div>
{/* Sección 16 - NUEVA E IMPORTANTE */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">16. Terminación y Suspensión de Cuentas</h4>
  
  <h6 className="fw-bold">Terminación por Parte del Usuario:</h6>
  <p>
    Puedes cancelar tu cuenta en cualquier momento desde tu panel de usuario o enviando 
    una solicitud a <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>.
  </p>
  <ul className="mb-3">
    <li>Al cancelar, tus datos permanecerán 6 meses (ver Sección 10)</li>
    <li>Puedes solicitar eliminación inmediata bajo Derechos ARCO</li>
    <li>No hay penalizaciones por cancelación</li>
    <li>Los pagos realizados NO son reembolsables (salvo garantía de 30 días)</li>
  </ul>

  <h6 className="fw-bold mt-4">Suspensión o Terminación por Parte de LemmonTags:</h6>
  <p>
    Nos reservamos el derecho de suspender o terminar tu cuenta si:
  </p>
  <ul className="mb-3">
    <li>Violas estos Términos y Condiciones</li>
    <li>Realizas actividades fraudulentas o ilegales</li>
    <li>Usas el servicio para acosar, dañar o rastrear personas sin consentimiento</li>
    <li>Intentas acceder sin autorización a nuestros sistemas</li>
    <li>Proporcionas información falsa o engañosa repetidamente</li>
    <li>No pagas las cuotas correspondientes (en caso de suscripción activa)</li>
  </ul>

  <div className="alert alert-danger mb-3">
    <h6 className="mb-2">
      <i className="bi bi-ban me-2"></i>
      Proceso de Suspensión:
    </h6>
    <ol className="mb-0">
      <li>Te notificaremos por correo electrónico sobre la violación detectada</li>
      <li>Tendrás <strong>5 días hábiles</strong> para responder y corregir la situación</li>
      <li>Si no respondes o no corriges, procederemos con la suspensión</li>
      <li>En casos graves (fraude, ilegalidad), la suspensión será inmediata sin previo aviso</li>
    </ol>
  </div>

  <h6 className="fw-bold mt-4">Efectos de la Terminación:</h6>
  <ul className="mb-3">
    <li>Perderás acceso inmediato a tu cuenta y panel de usuario</li>
    <li>Tus Tags dejarán de funcionar (mostrarán mensaje de cuenta desactivada)</li>
    <li>Tus datos se conservarán conforme a la Sección 10 y Aviso de Privacidad</li>
    <li>No habrá reembolso de pagos ya realizados</li>
  </ul>

  <h6 className="fw-bold mt-4">Derecho de Apelación:</h6>
  <p>
    Si consideras que la suspensión fue injustificada, puedes apelar enviando un correo a{" "}
    <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a> con el asunto 
    "Apelación de Suspensión" dentro de los <strong>10 días hábiles</strong> posteriores 
    a la notificación. Revisaremos tu caso y responderemos en un plazo de 5 días hábiles.
  </p>
</section>

{/* Sección 18 - NUEVA Y CRÍTICA */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">18. Actualizaciones y Modificaciones del Servicio</h4>
  
  <div className="alert alert-info mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-cloud-arrow-up me-2"></i>
      Naturaleza del Servicio en la Nube
    </h6>
    <p className="mb-0">
      LemmonTags es un <strong>servicio basado en la nube (Software as a Service - SaaS)</strong> 
      que evoluciona constantemente. Esto significa que la plataforma, aplicaciones móviles, 
      interfaces, funcionalidades y características están en continuo desarrollo y mejora.
    </p>
  </div>

  <h6 className="fw-bold">Derecho a Modificar el Servicio:</h6>
  <p>
    <strong>Inqubits S.A. de C.V. se reserva el derecho</strong> de modificar, actualizar, 
    mejorar, agregar o eliminar funcionalidades del Servicio en cualquier momento y de forma 
    unilateral, sin previo aviso, incluyendo pero no limitado a:
  </p>
  <ul className="mb-3">
    <li>
      <strong>Interfaz de usuario (UI/UX):</strong> Diseño, colores, disposición de elementos, 
      navegación, menús
    </li>
    <li>
      <strong>Funcionalidades:</strong> Agregar nuevas características, modificar o eliminar 
      funciones existentes
    </li>
    <li>
      <strong>Panel de usuario:</strong> Estructura, opciones disponibles, flujos de trabajo
    </li>
    <li>
      <strong>Perfil público de Tags:</strong> Diseño y contenido mostrado cuando se escanea un Tag
    </li>
    <li>
      <strong>Métodos de comunicación:</strong> Canales de notificación, formatos de mensajes
    </li>
    <li>
      <strong>Integraciones:</strong> Servicios de terceros, APIs, proveedores de infraestructura
    </li>
    <li>
      <strong>Políticas y procedimientos:</strong> Procesos internos que afecten la experiencia del usuario
    </li>
  </ul>

  <div className="card border-warning mb-4">
    <div className="card-header bg-warning text-dark">
      <strong>
        <i className="bi bi-exclamation-triangle me-2"></i>
        Importante: No Hay Derecho a Reembolso por Cambios
      </strong>
    </div>
    <div className="card-body">
      <p>
        <strong>Las modificaciones al Servicio NO constituyen motivo de devolución, reembolso 
        parcial o total de tu suscripción</strong>, salvo en los siguientes casos excepcionales:
      </p>
      <ol className="mb-3">
        <li>
          <strong>Eliminación completa de funcionalidad principal:</strong> Si eliminamos una 
          característica que fue explícitamente anunciada como "funcionalidad principal" al 
          momento de tu compra (e.g., eliminación del sistema de localización GPS)
        </li>
        <li>
          <strong>Cambio que haga el servicio incompatible:</strong> Si un cambio hace que el 
          servicio sea completamente inutilizable en tu dispositivo y no existe alternativa razonable
        </li>
      </ol>
      <p className="mb-0">
        <strong>NO constituyen motivo de reembolso:</strong> Cambios en diseño, colores, 
        disposición de menús, modificación de funciones secundarias, mejoras de seguridad, 
        optimizaciones de rendimiento, o cambios que mejoren la experiencia general pero 
        modifiquen flujos de trabajo existentes.
      </p>
    </div>
  </div>

  <h6 className="fw-bold mt-4">Tipos de Actualizaciones:</h6>
  
  <div className="row mb-3">
    <div className="col-md-6 mb-3">
      <div className="card h-100 border-success">
        <div className="card-header bg-success text-white">
          <strong>Actualizaciones Menores</strong>
        </div>
        <div className="card-body">
          <p className="small mb-2"><strong>Sin previo aviso:</strong></p>
          <ul className="small mb-0">
            <li>Corrección de errores (bugs)</li>
            <li>Mejoras de rendimiento</li>
            <li>Actualizaciones de seguridad</li>
            <li>Cambios estéticos menores</li>
            <li>Optimizaciones de servidor</li>
            <li>Ajustes en textos o traducciones</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="col-md-6 mb-3">
      <div className="card h-100 border-primary">
        <div className="card-header bg-primary text-white">
          <strong>Actualizaciones Mayores</strong>
        </div>
        <div className="card-body">
          <p className="small mb-2"><strong>Con notificación previa:</strong></p>
          <ul className="small mb-0">
            <li>Rediseño completo de interfaz</li>
            <li>Nuevas funcionalidades principales</li>
            <li>Cambios en planes o precios</li>
            <li>Modificaciones a Términos sustanciales</li>
            <li>Eliminación de funciones principales</li>
            <li>Cambios que requieran acción del usuario</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <h6 className="fw-bold mt-4">Notificaciones de Cambios Mayores:</h6>
  <p>
    Para actualizaciones mayores que afecten significativamente tu experiencia, te notificaremos 
    con al menos <strong>7 días de anticipación</strong> mediante:
  </p>
  <ul className="mb-3">
    <li>Correo electrónico a tu dirección registrada</li>
    <li>Aviso destacado en el panel de usuario</li>
    <li>Notificación push en la aplicación móvil (si la tienes instalada)</li>
  </ul>

  <div className="alert alert-primary">
    <h6 className="mb-2">
      <i className="bi bi-arrow-clockwise me-2"></i>
      Beneficios de las Actualizaciones Continuas:
    </h6>
    <ul className="mb-0 small">
      <li><strong>Mejora constante:</strong> Nuevas funciones sin costo adicional</li>
      <li><strong>Seguridad:</strong> Protección actualizada contra amenazas</li>
      <li><strong>Corrección de errores:</strong> Mejor experiencia y estabilidad</li>
      <li><strong>Innovación:</strong> Acceso a las últimas tecnologías</li>
      <li><strong>Compatibilidad:</strong> Soporte para nuevos dispositivos y sistemas</li>
    </ul>
  </div>

  <p className="mt-3">
    <strong>Al continuar usando el Servicio después de una actualización, aceptas los cambios 
    realizados.</strong> Si no estás de acuerdo con una actualización mayor, puedes cancelar 
    tu suscripción conforme a la Sección 16.
  </p>
</section>

{/* Sección 19 - NUEVA Y CRÍTICA */}
<section className="mb-5">
  <h4 className="border-bottom pb-2 mb-3">19. Compatibilidad, Requisitos Técnicos y Actualizaciones Obligatorias</h4>
  
  <h6 className="fw-bold">Requisitos Mínimos del Sistema:</h6>
  <p>
    Para garantizar el correcto funcionamiento del Servicio, tu dispositivo debe cumplir con 
    los siguientes requisitos mínimos:
  </p>

  <div className="row mb-4">
    <div className="col-md-6 mb-3">
      <div className="card h-100 border-primary">
        <div className="card-header bg-primary text-white">
          <strong>
            <i className="bi bi-phone me-2"></i>
            Aplicación Móvil (Usuario)
          </strong>
        </div>
        <div className="card-body">
          <h6 className="small fw-bold">iOS:</h6>
          <ul className="small mb-2">
            <li>iOS 13.0 o superior</li>
            <li>iPhone 6s o superior (para NFC: iPhone 7+)</li>
            <li>Safari 13+ o Chrome 80+</li>
          </ul>
          <h6 className="small fw-bold">Android:</h6>
          <ul className="small mb-0">
            <li>Android 8.0 (Oreo) o superior</li>
            <li>Google Play Services actualizados</li>
            <li>Chrome 80+ o Firefox 75+</li>
            <li>NFC (para lectura de Tags NFC)</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="col-md-6 mb-3">
      <div className="card h-100 border-success">
        <div className="card-header bg-success text-white">
          <strong>
            <i className="bi bi-laptop me-2"></i>
            Navegadores Web (Panel)
          </strong>
        </div>
        <div className="card-body">
          <h6 className="small fw-bold">Navegadores Compatibles:</h6>
          <ul className="small mb-2">
            <li>Google Chrome 90+ (Recomendado)</li>
            <li>Mozilla Firefox 88+</li>
            <li>Safari 14+ (macOS)</li>
            <li>Microsoft Edge 90+</li>
          </ul>
          <h6 className="small fw-bold">Otros Requisitos:</h6>
          <ul className="small mb-0">
            <li>JavaScript habilitado</li>
            <li>Cookies habilitadas</li>
            <li>Conexión a Internet estable</li>
            <li>Resolución mínima: 1024x768</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div className="alert alert-danger mb-4">
    <h6 className="alert-heading">
      <i className="bi bi-exclamation-triangle me-2"></i>
      Obligación de Mantener Software Actualizado
    </h6>
    <p>
      <strong>Es responsabilidad del usuario mantener sus dispositivos, sistemas operativos, 
      navegadores y aplicaciones actualizados</strong> a las versiones compatibles con nuestro Servicio.
    </p>
    <p className="mb-3">
      <strong>Inqubits S.A. de C.V. NO se hace responsable</strong> por:
    </p>
    <ul className="mb-0">
      <li>
        <strong>Incompatibilidad con versiones antiguas:</strong> Si tu dispositivo u OS está 
        desactualizado y el Servicio no funciona correctamente
      </li>
      <li>
        <strong>Pérdida de funcionalidad:</strong> Si dejas de actualizar y nuevas características 
        requieren versiones más recientes
      </li>
      <li>
        <strong>Vulnerabilidades de seguridad:</strong> En dispositivos con software obsoleto
      </li>
      <li>
        <strong>Problemas de rendimiento:</strong> En hardware muy antiguo o con recursos insuficientes
      </li>
    </ul>
  </div>

  <h6 className="fw-bold mt-4">Actualizaciones Obligatorias de Aplicación:</h6>
  <p>
    Periódicamente lanzamos actualizaciones de la aplicación móvil y web que pueden incluir:
  </p>
  <ul className="mb-3">
    <li>Corrección de errores críticos de seguridad</li>
    <li>Mejoras de rendimiento y estabilidad</li>
    <li>Nuevas funcionalidades</li>
    <li>Compatibilidad con nuevas versiones de sistemas operativos</li>
    <li>Cambios en APIs o servicios de backend</li>
  </ul>

  <div className="card border-warning mb-4">
    <div className="card-header bg-warning text-dark">
      <strong>
        <i className="bi bi-download me-2"></i>
        Actualizaciones Obligatorias
      </strong>
    </div>
    <div className="card-body">
      <p>
        <strong>Algunas actualizaciones son obligatorias</strong> y pueden impedir el uso del 
        Servicio hasta que se instalen. Esto ocurre cuando:
      </p>
      <ul className="mb-3">
        <li>Hay vulnerabilidades críticas de seguridad</li>
        <li>Cambios en backend hacen incompatibles versiones antiguas</li>
        <li>Se requiere nueva funcionalidad esencial</li>
      </ul>
      <p className="mb-2">
        <strong>En estos casos:</strong>
      </p>
      <ul className="mb-0">
        <li>Recibirás una notificación indicando que debes actualizar</li>
        <li>La aplicación puede bloquearse hasta que actualices</li>
        <li>Tendrás un periodo de gracia de <strong>7 días</strong> para actualizar antes del bloqueo</li>
        <li><strong>NO constituye motivo de reembolso</strong> si no actualizas a tiempo</li>
      </ul>
    </div>
  </div>

  <h6 className="fw-bold mt-4">Descontinuación de Soporte para Versiones Antiguas:</h6>
  <p>
    Nos reservamos el derecho de <strong>descontinuar el soporte</strong> para versiones antiguas 
    de sistemas operativos, navegadores o dispositivos que representen menos del 5% de nuestra 
    base de usuarios activos.
  </p>

  <div className="alert alert-info mb-4">
    <h6 className="mb-2">
      <i className="bi bi-bell me-2"></i>
      Notificación de Descontinuación:
    </h6>
    <p className="mb-2">
      Te notificaremos con <strong>90 días de anticipación</strong> si tu dispositivo o versión 
      de OS dejará de ser compatible, mediante:
    </p>
    <ul className="mb-0">
      <li>Correo electrónico</li>
      <li>Notificación en la aplicación</li>
      <li>Aviso en el panel de usuario</li>
    </ul>
  </div>

  <h6 className="fw-bold mt-4">Incompatibilidad No Constituye Reembolso:</h6>
  <div className="alert alert-warning mb-0">
    <p className="mb-2">
      <strong>
        <i className="bi bi-x-circle me-2"></i>
        Importante:
      </strong>
    </p>
    <p className="mb-0">
      La incompatibilidad de tu dispositivo con el Servicio <strong>NO constituye motivo de 
      devolución o reembolso</strong>, salvo que:
    </p>
    <ol className="mb-0">
      <li>
        Tu dispositivo cumplía los requisitos al momento de la compra y dejó de ser compatible 
        sin previo aviso (muy poco común)
      </li>
      <li>
        No recibiste la notificación de descontinuación con 90 días de anticipación por error de 
        nuestro sistema
      </li>
    </ol>
    <p className="mt-2 mb-0">
      <strong>Es responsabilidad del usuario verificar compatibilidad antes de adquirir el servicio.</strong>
    </p>
  </div>
</section>

      {/* Footer */}
      <div className="text-center mt-5 pt-4 border-top">
        <p>
          Si tienes alguna pregunta sobre estos Términos, por favor contáctanos en{" "}
          <a href="mailto:soporte@lemmontags.com">soporte@lemmontags.com</a>
        </p>
      </div>
    </div>
  );
}

export default Terminos;